import CloseIcon from '@mui/icons-material/Close';
import Modal from 'react-modal';
import { IDeleteCorrespondenceInputModel } from 'inputModels';
import produce from 'immer';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { ICorrespondenceViewModel, ISolicitationViewModel } from 'viewModels';
import { FormControl } from '@mui/material';
import { useTheme } from 'styled-components';
import { SelectControled } from '../../SelectControled';
import { ContentModal, Header } from './style';
import { Button } from '../../Buttons/Button';
import { ReactComponent as DeleteIcon } from '../../../assets/icons/IconDelete.svg';
import { ReactComponent as ExpandArrowIcon } from '../../../assets/icons/iconExpandArrow.svg';
import { CardOpenSolicitation } from '../../Cards/CardOpenSolicitation';
import { useCorrespondences } from '../../../context/correspondences';

interface ModalDeleteCorrespondenceProps {
  isOpen: boolean;
  currentCorrespondenceSelected: ICorrespondenceViewModel;
  onRequestClose: () => void;
  solicitationsByCorrespondence: ISolicitationViewModel[];
  onRequestRemoveCorrespondence: (correspondenceDeleted: IDeleteCorrespondenceInputModel) => void;
}

export function ModalDeleteCorrespondence({
  isOpen,
  currentCorrespondenceSelected,
  onRequestClose,
  solicitationsByCorrespondence,
  onRequestRemoveCorrespondence,
}: ModalDeleteCorrespondenceProps) {
  const theme = useTheme();
  const { correspondencesSelectedByUser } = useCorrespondences();

  const MenuProps = {
    PaperProps: {
      style: {
        backgroundColor: theme.colors.background_white,
        color: theme.colors.secondary,
        maxHeight: 250,
      },
    },
  };

  const handleOnMouseOverCard = (row: number, column: number) => {
    setHasHoverCard(
      produce((draft) => {
        /*eslint-disable-next-line*/
        draft[row][column] = true;
      }),
    );
  };
  const handleOnMouseOutCard = (row: number, column: number) => {
    setHasHoverCard(
      produce((draft) => {
        /*eslint-disable-next-line*/
        draft[row][column] = false;
      }),
    );
  };

  const [defaultValues] = useState<ICorrespondenceViewModel>({
    id: '',
    name: '',
    type: 0,
    attachmentTypes: [],
    profileTypes: [],
  });

  const [hasHoverCard, setHasHoverCard] = useState<boolean[][]>(() => {
    return Array(...Array(24)).map(() => {
      return Array(...Array(31)).map(() => false);
    });
  });

  const { control } = useForm({
    reValidateMode: 'onChange',
    defaultValues,
  });

  const [correspondenceId, SetCorrespondenceId] = useState<any>('');

  const confirmRemoveCorrespondence = () => {
    const correspondenceDeleted: IDeleteCorrespondenceInputModel = {
      NewCorrespondenceId: correspondenceId,
      id: currentCorrespondenceSelected.id,
    };
    onRequestRemoveCorrespondence(correspondenceDeleted);
    SetCorrespondenceId('');
    onRequestClose();
  };

  const close = () => {
    SetCorrespondenceId('');
    onRequestClose();
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={close}
      overlayClassName="react-modal-overlay"
      className="react-delete-modal-content">
      <Header>
        <div className="subHeader">
          <DeleteIcon />
          <h1>Exclusão</h1>
        </div>
        <div className="close-div">
          <button type="button" onClick={close}>
            <CloseIcon fontSize="small" />
          </button>
        </div>
      </Header>
      <ContentModal>
        <div className="contentFlex">
          <h2 className="confirmationText">
            Tem certeza que quer excluir o serviço de correspondência?
            <p>{currentCorrespondenceSelected.name}</p>
          </h2>
        </div>
        {solicitationsByCorrespondence.length > 0 && (
          <>
            <h2 className="confirmationText">
              Ele está vinculado a solicitações, você deseja alterar o serviço de correspondência?
            </h2>
            <div>
              <div className="divDropDownList">
                <FormControl fullWidth>
                  <SelectControled
                    name="NewCorrespondenceId"
                    control={control}
                    displayEmpty
                    classes={{ select: 'select-style' }}
                    value={correspondenceId}
                    onChange={(el) => SetCorrespondenceId(el.target.value)}
                    MenuProps={MenuProps}
                    IconComponent={ExpandArrowIcon}
                    placeholderTitle="Selecione"
                    itens={correspondencesSelectedByUser
                      .filter(
                        (correspondence) => correspondence.id !== currentCorrespondenceSelected.id,
                      )
                      .map((correspondence) => ({
                        id: correspondence.id,
                        value: correspondence.name,
                      }))}
                  />
                </FormControl>
              </div>
            </div>
            <div className="contentSolicitations">
              <p className="info">Solicitações abertas ou em andamento</p>
              <div className="contentSolicitationOpened">
                {solicitationsByCorrespondence.map((solicitation, index) => {
                  return (
                    <CardOpenSolicitation
                      key={solicitation.id}
                      onMouseLeave={() => handleOnMouseOutCard(1 + index, index)}
                      onMouseEnter={() => handleOnMouseOverCard(1 + index, index + 1)}
                      zIndex={solicitationsByCorrespondence.length - index}
                      left={hasHoverCard[1][1] ? index * 91 : index * 15}
                      solicitation={solicitation}
                    />
                  );
                })}
              </div>
            </div>
            <p className="confirmationText">
              Ps.: Solicitações finalizadas permanecerão com o nome do Serviço.
            </p>
          </>
        )}
        <div className="buttonModal">
          <Button
            text="Cancelar"
            dimensions={{ width: '10rem', height: '2.25rem' }}
            onClick={close}
          />
          <Button
            text="Excluir"
            dimensions={{ width: '10rem', height: '2.25rem' }}
            onClick={confirmRemoveCorrespondence}
            disabled={solicitationsByCorrespondence.length > 0 && !(correspondenceId.length > 2)}
          />
        </div>
      </ContentModal>
    </Modal>
  );
}
